import { useEffect, useState } from 'react';
import { responseError } from '../../../../helpers';
import { advisorAPI } from '../../../../apis/AdvisorsAPI';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Label, Modal } from 'semantic-ui-react';
import { areasSimpleComplexNameMatch } from '../../../../helpers/nameAreas';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const CompanyAdvisorGroups = ({ activeMenu }) => {
  const [advisorGroups, setAdvisorGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const companyProfile = useSelector((state) => state.currentCompany);
  const dispatch = useDispatch()

  const getAdvisorGroups = async () => {
    setLoading(true)
    try {
      const { data } = await advisorAPI.get('/advisor-group/by-company', {
        params: {
          companyId: companyProfile?._id,
          withAdvisors: true,
        },
      });

      setAdvisorGroups(data.data);
    } catch (error) {
      responseError(error, undefined, 'getAdvisorGroups', dispatch);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (companyProfile?._id) {
      getAdvisorGroups();
    }

    // eslint-disable-next-line
  }, [companyProfile?._id]);

  return (
    <>
      {activeMenu === 'advisorGroup' && (
        <>
          <h1>Advisor Groups ({advisorGroups.length})</h1>
          {!loading ? <>
            <div className="flex-gap-5" style={{ gap: '15px' }}>
              {advisorGroups.map((advisorGroup, index) => (
                <div key={index} style={{width: '30%'}}>
                  <CardAdvisorGroup advisorGroup={advisorGroup} />
                </div>
              ))}
            </div>
          </> : <>
            <Icon loading name="asterisk" /> Loading ...
          </>}
        </>
      )}
    </>
  );
};

const CardAdvisorGroup = ({ advisorGroup }) => {
  const history = useHistory();
  const [showAreas, setShowAreas] = useState(false);
  const [showSnapshots, setShowSnapshots] = useState(false);
  const [showSimulators, setShowSimulators] = useState(false);
  const [showTaskManager, setShowTaskManager] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showInsigths, setShowInsigths] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const[showAdvisors, setShowAdvisors] = useState(false);

  const transformBack = (key) => {
    return key.toLowerCase().replace(' ', '_')
  }
  const SectionType = ({sectionName, sectionObj, show, i, setShowSection}) => {
  
    return (
      <>
        <div>
            <div>
              <strong>{sectionName} <span className='grayaccent'>{sectionObj.fields.length || 0}</span></strong>
            </div>
            <Button basic className='helper_button' size='mini' onClick={val => setShowSection(transformBack(sectionName))}>{show ? 'Hide' : 'Show'}</Button>
            {show && <div className='flex-wrap_fp_300' style={{marginTop: "5px"}}>
              {sectionObj.fields?.map((field, index2) => (
                <div key={i}>
                  <Label>
                    {areasSimpleComplexNameMatch[field] || areasSimpleComplexNameMatch[`${sectionName}:${field}`] || field}
                  </Label>
                </div>
              ))}
            </div>}
          </div>

      </>
    )
  }
  const setShowSection = (key) => {
    switch (key) {
      case 'areas': setShowAreas(!showAreas)
        break;
      case 'snapshots': setShowSnapshots(!showSnapshots)
        break;
      case 'simulators': setShowSimulators(!showSimulators)
        break;
      case 'task_manager': setShowTaskManager(!showTaskManager)
        break;
      case 'reports': setShowReport(!showReport) 
        break;
      case 'insights': setShowInsigths(!showInsigths)
        break;
      case 'settings': setShowSettings(!showSettings)
        break;
      default:
        break;
    }
    
  }

  const showSection = {
    'areas': showAreas, 
    'snapshots': showSnapshots, 
    'simulators': showSimulators, 
    'task_manager': showTaskManager, 
    'reports': showReport, 
    'insights': showInsigths, 
    'settings': showSettings
  }

  const transformTitle = (key) => {
    return key.toUpperCase().replace('_', ' ')
  }



  return (
    <>
      <div className="card-border-line">
        <h2>{advisorGroup.name}</h2>

        <div className="grid_fp">
          {['areas', 'snapshots', 'simulators', 'task_manager', 'reports', 'insights', 'settings'].map((section, i) => (
            <>
            <SectionType
              sectionObj= {advisorGroup[section]}
              sectionName= {transformTitle(section)}
              i = {i}
              show = {showSection[section]}
              setShowSection = {val => setShowSection(val)}
            />
            </>
          ))
        }
          <div className='text_undelined' onClick={() => setShowAdvisors(!showAdvisors)}>Advisors ({advisorGroup.advisors?.length || 0})</div>
        </div>
      </div>

      <Modal open={showAdvisors} size='tiny'>
        <Modal.Header>
          <div className='flex-gap-5' style={{justifyContent: "space-between"}}>
            <div>
              Advisors ({advisorGroup.name})
            </div>
            <div>
              <Button basic className='helper_button' onClick={() => setShowAdvisors(!showAdvisors)} icon size="mini"><Icon name='close' /></Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content>
          <ul>
            {advisorGroup.advisors?.map((advisor, index3) => (
              <li key={index3} style={{cursor: "pointer"}} onClick={() => history.push(`/dashboard/advisors/${advisor._id}`)}>
                {advisor.fullName} ({advisor.email})
              </li>
            ))}
          </ul>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default CompanyAdvisorGroups;
